import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';


class LandingSlider extends React.Component {
    static propTypes = {
        slides: PropTypes.arrayOf(PropTypes.shape({
            picture: PropTypes.string.isRequired,
            text: PropTypes.string,
        })).isRequired,
    };

    renderSlide(text, picture, i) {
        const key = `slide-${i}`;
        const styles = {
            backgroundImage: `url(${picture})`,
        };

        return (
            <div className="slide-container" style={styles} key={key}>
                <div className="wrapper">
                    <div className="container">
                        <div className="content-table">
                            <div className="slide-text">{text}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const settings = {
            dots: true,
            centerMode: false,
            cssEase: 'ease',
            currentSlide: 3,
            fade: false,
            focusOnSelect: null,
            infinite: true,
            lazyLoad: false,
            rtl: false,
            autoplay: true,
            autoplaySpeed: 5000,
            slideCount: 3,
            speed: 500,
        };

        return (
            <div className="landing-slider">
                <Slider {...settings}>
                    {this.props.slides.map((data, i) => this.renderSlide(data.text, data.picture, i))}
                </Slider>
            </div>
        );
    }
}


export default LandingSlider;



// WEBPACK FOOTER //
// ./src/components/LandingSlider.js